/**
 * Offline indicator — shows a banner when the network is unavailable.
 * Uses an aria-live region so screen readers announce status changes.
 */
import { useEffect, useState } from 'react';
import { CloudOff } from 'lucide-react';

export function OfflineIndicator() {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center gap-2 border-b border-[var(--color-rule)] bg-[var(--color-surface)] px-4 py-2 text-sm font-medium text-[var(--color-ink)] safe-px"
    >
      <CloudOff className="h-4 w-4" />
      <span>You are offline. Some features may be unavailable.</span>
    </div>
  );
}
